require('./bootstrap-home');



// WEBPACK FOOTER //
// ./resources/assets/js/home.js